import React, { useState } from "react";
import DeleteModal from "../../../../components/Common/DeleteModal";
import { usePagination } from "../../../../hooks/usePagination";
import ResultHandler from "../../../../components/ResultHandler";
import PaginationHandler from "../../../../components/PaginationHandler";
import TableHeaderHandler from "../../../../components/TableHeaderHandler";
import { useTranslation } from "react-i18next";
import { useResponse } from "../../../../hooks/useResponse";
import TableAction from "../../../../components/TableAction";
import EmptyData from "../../../../components/EmptyData";
import { Table, Thead, Tbody, Td, Tr, Th } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { PERMISSIONS } from "../../../../api/permissions";
import { getContracts, deleteContract } from "../../../../api/contract";
import { useParams } from "react-router-dom";
import moment from "moment";
import { Button } from "reactstrap";
import AssignAdminModal from "./AssignAdminModal";
import { useHistory } from "react-router-dom";
import { formatCurrency } from "../../../../utils/formatCurrency";
import TableFilter from "../../../../components/TableFilter";

export default function ContractsTable({ hideTableAction, hideTableHeader }) {
  const { t } = useTranslation();
  const history = useHistory();

  const { id:companyId } = useParams();

  const {
    response,
    loading,
    error,
    setPage,
    page,
    setPerPage,
    totalPages,
    setPayload,
    setMeta
  } = usePagination(getContracts, { companyId, active: true });

  function handleRefresh() {
    setPayload({ companyId: id, ref: true });
  }

  //// delete
  const [show, setShow] = useState(false);

  function onCloseClick() {
    setShow(false);
  }

  const [deletingContract, setDeletingContract] = useState(null);

  const { setData } = useResponse(deleteContract, () => {
    setShow(false);
    setDeletingContract(null);
    handleRefresh();
  });

  function onDeleteClick() {
    setData({ type: "add", data: deletingContract });
  }

  //////////// assign admin

  const [selectedContract, setSelectedContract] = useState(null);

  // Filter
  const filterTypes = [
    {
      key: "active",
      type: "select",
      label: "Status",
      options: [
        { label: "Active", value: true },
        { label: "Not Active", value: false },
        { label: "All", value: "all" },
      ],
    },
  ];

  return (
    <>
      {!hideTableHeader && (
        <TableHeaderHandler
          permission={PERMISSIONS.EMPLOYEE_CREATE}
          setPage={setPage}
          setPerPage={setPerPage}
          addUrl="add-contract"
        ></TableHeaderHandler>
      )}

      <TableFilter
        filterTypes={filterTypes}
        onFilter={(filters) =>
          setMeta({ page: 1, payload: { companyId, ...filters} })
        }
      />


      <div className="table-rep-plugin">
        <div className="table-responsive">
          <Table className="table table-striped table-bordered">
            <Thead className="table-light table-nowrap">
              <Tr>
                <Th>Pool Title</Th>
                <Th>Start Date</Th>
                <Th>End Date</Th>
                <Th>Status</Th>
                <Th>Skill Rewards</Th>
                <Th>Task Details</Th>
                <Th>Pool</Th>
                <Th>Invoiceables</Th>
                <Th>Invoices</Th>
                {!hideTableAction && (
                  <Th style={{ width: "10%" }}>{t("tables.Action")}</Th>
                )}
              </Tr>
            </Thead>

            {response.data && !loading && (
              <Tbody>
                {response.data.company_contracts.map((row) => {
                  return (
                    <Tr key={row.id}>
                      <Td>
                        {row.jobTitle}
                        <Button
                          onClick={() => setSelectedContract(row)}
                          style={{ display: "block" }}
                          color="dark"
                          size="sm"
                        >
                          {row?.admins?.length > 0
                            ? row.admins[0].username
                            : "Assign Admin"}
                        </Button>
                      </Td>
                      <Td>{moment(row.startDate).format("DD MMM YYYY")}</Td>
                      <Td>{moment(row.endDate).format("DD MMM YYYY")}</Td>
                      <Td>{row.status}</Td>
                      <Td>{row.skillRewards ? "Yes" : "No"}</Td>
                      <Td>
                        {row.taskDetails && (
                          <a
                            href={row.taskDetails}
                            className="text-info fw-bold"
                          >
                            Download
                          </a>
                        )}
                      </Td>
                      <Td>
                        {!row.pool && (
                          <Button
                            size="sm"
                            onClick={() => history.push("/add-pool/" + row.id)}
                            color="dark"
                          >
                            Add Pool
                          </Button>
                        )}
                        {row.pool && (
                          <div className="d-flex align-items-center gap-1 mb-2">
                            <Button
                              size="sm"
                              onClick={() =>
                                history.push("/pool-hours/" + row.pool.id)
                              }
                              color="dark"
                            >
                              {row.pool.name}
                            </Button>
                            <Button
                              size="sm"
                              onClick={() =>
                                history.push("/edit-pool/" + row.pool.id)
                              }
                              color="primary"
                            >
                              <i className="bx bx-edit font-size-16 align-middle" />
                            </Button>
                            <Button
                              size="sm"
                              onClick={() =>
                                history.push("/add-collection/" + row.pool.id)
                              }
                              color="primary"
                            >
                              <i className="bx bx-time font-size-16 align-middle" />
                            </Button>
                          </div>
                        )}
                      </Td>

                      <Td className="text-center">
                        <Button
                          size="sm"
                          onClick={() =>
                            history.push("/contract-invoiceables/" + row.id)
                          }
                          color="dark"
                        >
                          View
                        </Button>
                      </Td>
                      <Td className="text-center">
                        <Button
                          size="sm"
                          onClick={() =>
                            history.push("/contract-invoices/" + row.id, {
                              companyName: row.company.name,
                              contractName: row.jobTitle,
                            })
                          }
                          color="dark"
                        >
                          View
                        </Button>
                      </Td>
                      {!hideTableAction && (
                        <Td>
                          <TableAction
                            hasEdit={true}
                            hasDelete={true}
                            editPermission={PERMISSIONS.EMPLOYEE_EDIT}
                            deletePermission={PERMISSIONS.EMPLOYEE_DELETE}
                            type="contract"
                            id={row.id}
                            setShow={setShow}
                            setDeleteIntitiy={setDeletingContract}
                          />
                        </Td>
                      )}
                    </Tr>
                  );
                })}
              </Tbody>
            )}
          </Table>

          {!loading && (
            <EmptyData
              empty={
                response.data && response.data.company_contracts.length === 0
              }
              msg="No Contracts Found."
            />
          )}

          {response.data && !loading && (
            <PaginationHandler
              page={page}
              setPage={setPage}
              totalPages={totalPages}
            />
          )}

          <ResultHandler error={error} loading={loading} />

          <DeleteModal
            show={show}
            onDeleteClick={onDeleteClick}
            onCloseClick={onCloseClick}
          />

          <AssignAdminModal
            isOpen={selectedContract ? true : false}
            contract={selectedContract}
            handleClose={() => setSelectedContract(null)}
            onSuccess={() => {
              handleRefresh();
            }}
          />
        </div>
      </div>
    </>
  );
}
